'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'

import { DeliverySupportCookies, useDeliverySupport } from 'modules/delivery'

import { useDisplayCart } from '../../../store/cartStore'

// The delivery area follows the cart address; without one, the area saved in
// the cookies is re-validated. Runs only once the cart exists.
export const useSyncSelectedDeliveryFromCart = () => {
  const session = useSession()
  const cart = useDisplayCart()
  const { validateAndUpdateAddress } = useDeliverySupport()

  useEffect(() => {
    if (session.status === 'loading' || !cart?.id) return

    const cookiesAddress = DeliverySupportCookies.get()

    const cartPostalCode = cart?.deliveryAddress?.postalCode
    const cartCity = cart?.deliveryAddress?.city

    const postalCodeToUse = cartPostalCode || cookiesAddress.postalCode || ''
    const cityToUse = cartCity || cookiesAddress.city || ''

    if (postalCodeToUse) {
      void validateAndUpdateAddress(
        {
          postalCode: postalCodeToUse,
          city: cityToUse
        },
        true
      )
    }
  }, [
    cart?.deliveryAddress,
    cart?.id,
    session.status,
    validateAndUpdateAddress
  ])
}
